import type { IActivityContext } from '../cards/activity-cards';
import type {
  ICartadigitalAdminHostToolDeps,
  IGpthelpToolScope,
} from '../tools/tool-types';

/** Where and when the activity is read: the store, its branch's time zone, now. */
export function activityContextFor(
  deps: Pick<ICartadigitalAdminHostToolDeps, 'restaurantStore'>,
  scope: Pick<IGpthelpToolScope, 'restaurantId' | 'timeZone'>
): IActivityContext {
  return {
    restaurantId: scope.restaurantId,
    storeName: deps.restaurantStore.restaurant?.name ?? '',
    timeZone: scope.timeZone,
    now: new Date(),
  };
}
